/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Save_To_Space_TitleInputs */



/**
* | output |
* | --- |
* | "Save a file into a space" |
*
* @param {Chat_Save_To_Space_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_save_to_space_title = /** @type {((inputs?: Chat_Save_To_Space_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Save_To_Space_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei in einem Space speichern")
	return /** @type {LocalizedString} */ ("Save a file into a space")
});